import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { HrTabGroupComponent } from './hr-tab-group/hr-tab-group.component';
import { HrTabComponent } from './hr-tab/hr-tab.component';
import { TestDashboardComponent } from './test-dashboard/test-dashboard.component';
import { AdvancedButtonComponent } from './advanced-button/advanced-button.component';
import { IconComponent } from './icon/icon.component';
import { MatDialogModule } from '@angular/material/dialog';
import { InfoPopupComponent } from './info-popup/info-popup.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { PagingComponent } from './paging/paging.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmActionDialogComponent } from './confirm-action-dialog/confirm-action-dialog.component';
import { ExceptionDialogComponent } from './exception-dialog/exception-dialog.component';
import { RouterModule } from '@angular/router';
import { AdvancedTabComponent } from './advanced-tab/advanced-tab.component';
import { AdvancedTabGroupComponent } from './advanced-tab-group/advanced-tab-group.component';
import { HrFancyCheckboxComponent } from './hr-fancy-checkbox/hr-fancy-checkbox.component';
import { ConnectFormDirective } from './directives/connect-form.directive';
import { RoutablePagingComponent } from './routable-paging/routable-paging.component';
import { AlertPopupComponent } from './alert-popup/alert-popup.component';
import { InfoPopupDialogComponent } from './info-popup-dialog/info-popup-dialog.component';
import { RestrictedComponent } from './restricted-page/restricted.component';
import { SortableHeaderComponent } from './sortable-header/sortable-header.component';

@NgModule({
  declarations: [
    ButtonComponent, IconButtonComponent, HrTabGroupComponent, 
    HrTabComponent, TestDashboardComponent, AdvancedButtonComponent, 
    IconComponent, ConfirmationDialogComponent, ConfirmActionDialogComponent, InfoPopupComponent, AlertPopupComponent,
    SpinnerComponent,
    PagingComponent,
    SafeHtmlPipe,
    ErrorMessageComponent,
    HrFancyCheckboxComponent,
    ConnectFormDirective,
    InfoPopupDialogComponent,
    ExceptionDialogComponent,
    RestrictedComponent,
    AdvancedTabComponent,
    AdvancedTabGroupComponent,
    RoutablePagingComponent,
    SortableHeaderComponent
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    MatDialogModule,
    MatSnackBarModule,
    TranslateModule,
    RouterModule
  ],
  exports: [
    ButtonComponent,
    IconButtonComponent,
    IconComponent,
    HrTabGroupComponent,
    InfoPopupDialogComponent,
    HrTabComponent,
    AdvancedButtonComponent,
    SpinnerComponent,
    RestrictedComponent,
    PagingComponent,
    SafeHtmlPipe,
    ErrorMessageComponent,
    HrFancyCheckboxComponent,
    ConnectFormDirective,
    ConfirmationDialogComponent,
    ConfirmActionDialogComponent,
    ExceptionDialogComponent,
    AdvancedTabComponent,
    AdvancedTabGroupComponent,
    RoutablePagingComponent,
    SortableHeaderComponent
  ]
})
export class UiModule { }
